import test_1 from "../assets/images/test1.jpeg";
import test_2 from "../assets/images/test2.jpeg";

export const guestfilterinboxby = [
  'test1 - 912 n creek dr  edmond, OK 73034',
  'test group (405) 924-9458',
  'test2 - 912 n creek dr  edmond, OK 73034',
  'michel shall - (405) 439-6082',
];
export const propertiesunitscampaigns = [
  {
    value: 'test1 - 912 n creek dr  edmond, OK 73034',
    label: 'test1 - 912 n creek dr  edmond, OK 73034',
  },
  {
    value: 'test1 - 912 n creek dr  edmond, OK 73034 - $0.00',
    label: 'test1 - 912 n creek dr  edmond, OK 73034 - $0.00',
  },
]
export const gueststatus = [
  {
    value: 'Pre-Qualified',
    label: 'Pre-Qualified',
  },
  {
    value: 'Active',
    label: 'Active',
  },
  {
    value: 'Application Completed',
    label: 'Application Completed',
  },
  {
    value: 'Inactive',
    label: 'Inactive',
  },
  {
    value: 'Cold',
    label: 'Cold',
  },
]
export const guestcsrdssource = [
  {
    value: 'Abodo',
    label: 'Abodo',
  },
  {
    value: 'Apartment Advisor',
    label: 'Apartment Advisor',
  },
  {
    value: 'Apartment List',
    label: 'Apartment List',
  },
  {
    value: 'Apartments.com',
    label: 'Apartments.com',
  },
  {
    value: 'ClassifiedAds',
    label: 'ClassifiedAds',
  },
  {
    value: 'Dwellsy',
    label: 'Dwellsy',
  },
  {
    value: 'Homes.com',
    label: 'Homes.com',
  },
]
export const guestcsrdleadtype = [
  {
    value: 'Free',
    label: 'Free',
  },
  {
    value: 'Premium',
    label: 'Premium',
  },
  {
    value: 'Hang Up',
    label: 'Hang Up',
  },
  {
    value: 'Refunded',
    label: 'Refunded',
  },
]
export const guestcsrdassignedto = [
  {
    value: 'Unassigned',
    label: 'Unassigned',
  },
  {
    value: 'Allan Miraflor',
    label: 'Allan Miraflor',
  },
  {
    value: 'Zumper',
    label: 'Zumper',
  },
  {
    value: 'Derek Dorris',
    label: 'Derek Dorris',
  },
]
export const guestcardsreport = [
{
    key: '1',
    name: 'John Smith',
    age: 32,
    address: 'Lorem ipsum dolor sit amet,',
    tags: ['Lorem ipsum', 'Lorem ipsum'],
  },
  {
    key: '2',
    name: 'Jim Green',
    age: 42,
    address: 'Lorem ipsum dolor sit amet,',
    tags: ['Lorem ipsum'],
  },
  {
    key: '3',
    name: 'Joe Black',
    age: 32,
    address: 'Lorem ipsum dolor sit amet,',
    tags: ['Lorem ipsum', 'Lorem ipsum'],
  },
]
export const contactinfo = [

  {
    value: 'kelly s - (405) 888-9090',
    label: 'kelly s - (405) 888-9090',
  },
  {
    value: 'shanon sepory - (405) 924-9458',
    label: 'shanon sepory - (405) 924-9458',
  },
  {
    value: 'Star Vick - (405) 609-4507',
    label: 'Star Vick - (405) 609-4507',
  },
  {
    value: 'michel shall - (405) 439-6082',
    label: 'michel shall - (405) 439-6082',
  },
  {
    value: 'Tonya Scales - (405) 201-7193',
    label: 'Tonya Scales - (405) 201-7193',
  },

]
export const guestcardinbox = [

  {
    key: '1',
    title: 'Needs First Contact',
    body: "There's nothing to see here. You're all caught up!",
    notification: 1,
  },
  {
    key: '2',
    title: 'Needs Follow Up',
    body: "There's nothing to see here. You're all caught up!2",
    notification: 2,
  },
  {
    key: '3',
    title: 'Going Cold',
    body: "There's nothing to see here. You're all caught up! 3",
    notification: 4,
  },

];

export const propertyCardData = [
  {
    id: 1,
    propertyName: "GF3, Block 58, Seaview Apartments, DHA Phase 5 - Test 3",
    address: "GF3, Block 58, Seaview Apartments, DHA Phase 5 - Test 3 P/O Sost Nazimabad, Gojal Hunza, Hunza Nagar Karachi, 75500",
    media: [test_1, test_2],
    bedRooms: 0,
    bathRooms: 0,
    squareFeet: 0,
    availabel: "yes",
    rent: 400,
    rented: false,
    rentType: "Never Rented"
  },
  {
    id: 2,
    propertyName: "Test 2",
    address: "1800 canyon park circle edmond, OK 73013",
    media: [test_2, test_1],
    bedRooms: 0,
    bathRooms: 0,
    squareFeet: 0,
    availabel: "no",
    rent: 500,
    rented: false,
    rentType: "Never Rented"
  },
  {
    id: 3,
    propertyName: "1817 Treat Drive",
    address: "1817 Treat Drive Midwest City, OK 73110",
    media: [test_2, test_1],
    bedRooms: 4,
    bathRooms: 2,
    squareFeet: 1196,
    availabel: "02/20/2023",
    rent: 875,
    rented: true,
    rentType: "Vacant For: 1 days"
  },
];

export const users = [
  {value:"Ibrahim"},
  {value:"william"},
  {value:"john"},
  {value:"jessica"},
];

export const lockBoxes = [
  {
    key: 1,
    lockBoxName: "1379",
    unit: "2524 1/2 NW 12th St.",
    unlockCode: "1379",
  },
  {
    key:2,
    lockBoxName: "test 2",
    unit: "Dummy Box",
    unlockCode: "012",
  },
];

export const codeboxLockBoxes = [
  {
    key:3,
    serialNumber: "10005163",
    lockBoxName: "10005163",
    unit: "",
    unlockCode: "1379",
  },
  {
    key:4,
    serialNumber: "10005493",
    lockBoxName: "10005493",
    unit: "",
    unlockCode: "012",
  },
  {
    key:5,
    serialNumber: "10005493",
    lockBoxName: "10005493",
    unit: "6317 S Phillips Avenue",
    unlockCode: "012",
  },
  {
    key:6,
    serialNumber: "10005493",
    lockBoxName: "10005493",
    unit: "2200 NW 12th Street",
    unlockCode: "012",
  },
];

for(let i=7 ; i <=20; i++){
  codeboxLockBoxes.push({
    key:i,
    serialNumber: "10005493",
    lockBoxName: "10005493",
    unit: "2200 NW 12th Street",
    unlockCode: "012",
  },)
}
